/* eslint-disable sort-keys */
export const infoMessage = {
    '> div:first-child svg': {
        width: '$alertIcon',
        color: '$alertIconInfo',
    },
    'backgroundColor': '$alertBackgroundInfo',
    'borderColor': '$alertBorderInfo',
    'borderStyle': 'solid',
    'borderWidth': '$alert',
    'borderRadius': '$alertBorder',
    'display': 'flex',
    'margin': '10px 0',
    'gap': '$alertItemsGap',
    'padding': '$alertPaddingVertical $alertPaddingHorizontal',
    'variants': {
        variant: {
            default: {},
            warning: {
                '> div:first-child svg': {color: '$alertIconWarning'},
                'backgroundColor': '$alertBackgroundWarning',
                'borderColor': '$alertBorderWarning',
            },
            error: {
                '> div:first-child svg': {color: '$alertIconError'},
                'backgroundColor': '$alertBackgroundError',
                'borderColor': '$alertBorderError',

            },
            success: {
                '> div:first-child svg': {color: '$alertIconSuccess'},
                'backgroundColor': '$alertBackgroundSuccess',
                'borderColor': '$alertBorderSuccess',
            },
        },
        onModal: {
            true: {background: 'transparent'},
            false: {},
        },
    },
}

export const infoHeader = {
    fontWeight: 'bold',
    marginBottom: '5px',
}
